import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {Panel, FormLayout, Input} from 'components';

const TimeOffRules = observer(({uiState}) => {
  const {policy, errors} = uiState;

  return (
    <div>
      <Panel.Header 
        title={t('time_off.policy.edit.RULES', { name: policy.name })} 
        description={t('time_off.policy.edit.Configure the rules when an employee takes this type of time off and how it accrues.')}
      />
      <FormLayout>
        <Input
          value={policy.name}
          onChange={e => policy.merge({name: e.target.value})}
          errorMessage={errors.name}
        />
      </FormLayout>
    </div>
  );
});

export default TimeOffRules;
